import {User} from '../classes/user/User';
import {AbstractChatMessage} from '../classes/message/abstract-chat-message';
import {Item} from '../classes/item/Item';

import { Member } from '../classes/system/member/Member';
import { DictionaryMessage, } from '../classes/message/DictionaryMessage';
import { LeitnerMessage } from '../classes/message/LeitnerMessage';
import { ChatMessage } from '../classes/message/chat-message';
import { DicLang, ITEM_TYPES } from '../item/item-types';
import { Section } from './Section';
import { QuizMessage } from '../classes/quiz/quiz-message';

 export class Chat {

    public id: number;
    public title: string;
    public item : Item | null;
    public sortedByScheduledTime: boolean = false;
    public name: string;
    public tutorial : boolean = false;
    public description: string;
    public type: ITEM_TYPES;
    public chatID: string;
    public storageID : string;
    public sections : Section[] = [];
    public messages : Array<AbstractChatMessage> = [];
    public scheduledMessages : Array<AbstractChatMessage> = [];
    public searchedMessages : Array<AbstractChatMessage>;
    public members : Array<Member>;
    public admins : Array<Member>;
    public unreadMessagesNumber : number = 0;
    public sortedMessages :any;
    public currentSegment = 0;
    public lastMessageRowID = 10000000;
    public static typeLeitner = "leitner";
    public static typeDictionary = "dictionary";
    public static typeartikelQuiz = "artikelQuiz";
    public static typeChat = "chat";
    public static typeLesson = "lesson";
    public remainedMessagesLength : number = 10;
    public reviewWords : boolean = false;
    public searching : boolean = false;
    public messageOptionOverlay : boolean = false;
    public firstUsage : boolean = false;
    public viewLoaded : boolean = false;
    public finishedTutorial : boolean = true;
    public clipBoardText: string = "";
    public joined : boolean;
    public public : boolean;
    public creatorID: string;
    public highlighted: boolean = false;
     optionMenuShow: boolean;
     remaindMessagesOnline: number = 10;
    currentDicLang:DicLang =  DicLang.deFa;
     topIndex: number = 0;
     pageNumber: number = -20;
     referenceMessage: AbstractChatMessage;
     bottomIndex: number = 0;
    constructor(chatOrItem:any){
        if(!chatOrItem){
            this.members = [];
            this.admins = [];
            this.messages = [];
            this.public = false;
            this.searchedMessages = [];
            this.sortedMessages = [];
            this.unreadMessagesNumber = 0;
            this.sortedMessages = {0:[],1:[],2:[],3:[],4:[]};
        }
        else if (chatOrItem && Object.keys(chatOrItem).length >0) {
            this.members = [];
            this.admins = [];
            this.title = chatOrItem.title;
            this.name = "collection.name";
            this.type = chatOrItem.type;
            this.public = chatOrItem.public;
            if(chatOrItem.unreadMessagesNumber)
                this.unreadMessagesNumber = chatOrItem.unreadMessagesNumber;
            else
                this.unreadMessagesNumber = 0;
            this.storageID = chatOrItem.storageID;
            if (this.storageID != undefined){
                this.chatID = this.storageID;
            }
            if (chatOrItem.itemID != undefined ){
                this.chatID = chatOrItem.itemID;
            }
            if (chatOrItem.chatID != undefined ){
                this.chatID = chatOrItem.chatID;
            }
            this.messages = [];
            if(chatOrItem.messages != undefined ) {
                for (let message of chatOrItem.messages){
                    // this.logger.debug("message of type",message);
                    let msg;
                    if(message.type == "quiz")
                        msg = new QuizMessage();
                    else
                        msg = new DictionaryMessage();
//                    this.logger.debug("for chat",this,"messages",msg);
                    // this.messages.push(msg);
                }
            }
            this.searchedMessages = [];
//            this.sortedMessages = {0:[],1:[],2:[],3:[],4:[]};
//            if(chatOrItem.sortedMessages){
//                this.sortedMessages = chatOrItem.sortedMessages;
//            }
//            this.getSortedMesages(0);
            if(chatOrItem.members){
                for(let memberIndex in chatOrItem.members){
                    this.members.push(new Member(chatOrItem.members[memberIndex]));
                }
            }
        }
        if (this.isLeitner())
            this.setReviewWords(true);
    }
    setFirstUsage(isFirstUsage: boolean){
        this.firstUsage = isFirstUsage;
    }
    isFirstUsage(){
        return this.firstUsage;
    }
    getTitle(){
        return this.title;
    }
    getCreatorID(){
        return this.creatorID;
    }
    setCreatorID(creatorID : string){
        this.creatorID = creatorID;
    }
    setReviewWords(isEnable : boolean){
        this.reviewWords = isEnable;
    }
    hasClipBoardText(){
        return this.clipBoardText.length > 0;
    }
    setClipBoardText(clipBoardText: string){
        this.clipBoardText = clipBoardText;
    }
    getClipBoardText(){
        return this.clipBoardText;
    }

    clearMessages(){
        this.messages.length = 0;
    }
    setMessageOptionOverlay(enable : boolean){
        this.messageOptionOverlay = enable;
        if(!enable)
            for (let message of this.messages){
                message.setShowOptionMenu(false);
            }
    }
    isShowOptionMenu() : boolean{
        return this.optionMenuShow;
    }
    setShowOptionMenu(show : boolean){
        this.optionMenuShow = show;
    }
    isMessageOptionOverlay(){
        return this.messageOptionOverlay;
    }
    getSortedMesages(sortedNumber : number){
        this.messages.length = 0;
        let messages = this.sortedMessages[sortedNumber];
        if(messages){
            // for(let msgIndex in messages){
            //     this.searchedMessages.push(new DictionaryMessage());
            //     this.messages.push(new DictionaryMessage());
            // }
        }
    }
    readAllMessages(){
        this.unreadMessagesNumber = 0;
    }
    setMessages(messages:Array<AbstractChatMessage>){
        this.messages.length = 0;
        this.searchedMessages.length = 0;
        for(let message of messages){
            this.addMessage(message);
        }
    }
    setInSortedMessages(){
//        if (this.sortedMessages !== undefined)
//            this.sortedMessages = {};
        var clonedMessages = Object.assign({}, this.messages);
        this.sortedMessages[this.currentSegment] =clonedMessages;
    }
    changeSegment(segmentIndex:number){
        this.currentSegment = segmentIndex;
    }
    getSimpleModel(){
        let chatData  = Object.assign({}, this);
        let chat = new Chat(chatData);
        chat.messages = [];
        chat.members = [];
        chat.sortedMessages = [];
        chat.searchedMessages = [];
        chat.item = null;
        return chat;
    }
    getMemberIDs(){
        let memberIDs = [];
        for( let member of this.members){
            memberIDs.push(member.userID);
        }
        return memberIDs;
    }
    getSimpleModelWithMessages(){
        let chatData  = Object.assign({}, this);
        let chat = new Chat(chatData);
        chat.messages = this.messages;
        
        chat.sortedMessages = [];
        chat.searchedMessages = [];
        chat.item = null;
        return chat;
    }
    isOwner(user: User){
            return this.getCreatorID() == user.userID;
    }
    isMember(user :User ){
        let memberIds = this.getMemberIDs();
        return this.getMemberIDs().indexOf(user.userID) >= 0;
    }
    hasMembers(){
        return this.members.length>0;
    }
    getSegmentLength(segmentNumber : number){
//        if (this.sortedMessages)
//        return "2";
//        this.logger.debug("here are sorted messages", this.sortedMessages[segmentNumber].length);
//        return Object.keys(this.sortedMessages[segmentNumber]).length;
        return 0;
    }
    // search(needle : string){
    //     this.messages = this.searchedMessages;
    //     this.messages = this.messages.filter(message=>{
    //         if(message.content.includes(needle))
    //             return message;
    //     })
    // }
    searchIn(messages : Array<AbstractChatMessage>){
        this.messages = messages;
    }
    endSearch(){
        this.messages = this.searchedMessages;
    }
    getLastMessageDate(){
        if(this.messages.length>0)
            return this.messages[this.messages.length-1].receivedTime;
        else
            return "00-00-00 00:00:00";
    }
    getLastMessageSummary(){
        if(this.messages.length>0){
            return this.messages[this.messages.length-1].getSummary();
        }
        else 
            return "";
    }
    getLastMessageID(){
        if(this.messages.length>0)
            return this.messages[this.messages.length - 1].messageID;
        else
            return null;
    }
    getFirstMessageID(){
        if(this.messages.length>0){
            return this.messages[0].messageID;
        }
        else
            return null;
    }
    getFirstScheduledMessageID(){
        if(this.scheduledMessages.length>0)
            return this.scheduledMessages[0].messageID;
        else
            return null;
    }
    addMessage(message : AbstractChatMessage){
        this.messages.push(message);
    }
    prependMessage(message : AbstractChatMessage){
//        this.getSortedMesages(0);
//        var clonedMessage = Object.assign({}, message);
//        clonedMessage.type = "leitner";
        this.messages.unshift(message);
//        this.setInSortedMessages();
    }
//     addMessageToLeitner(message : AbstractChatMessage){
// //        this.getSortedMesages(0);
//         let clonedMessageObject = Object.assign({}, message);
//         clonedMessageObject.type = Chat.typeLeitner;
//         let clonedMessage = new LeitnerMessage();
//         clonedMessage.setMessageID(clonedMessage.messageID+"leitner");
//         this.addMessage(clonedMessage);
// //          this.messages.push(clonedMessage);
//         return clonedMessage;
// //        this.setInSortedMessages();
//     }
    hasMessagesInDatabase(){
        return this.remainedMessagesLength > 0;
    }
    hasMessagesOnline(){
        return this.remaindMessagesOnline > 0;
    }
    isLeitner(){
        return this.type == Chat.typeLeitner; 
    }    
    isLesson(){
        return this.type == Chat.typeLesson; 
    }
    isDictionary(){
        // this.logger.debug("isDictionary", this.type, Chat.typeDictionary)
        return this.type == Chat.typeDictionary ; 
    }
    hasPremissionToSendMessage(){
        return this.isDictionary() || this.isChat();
    }
    isChat(){
        return this.type == Chat.typeChat; 
    }
    isQuiz(){
        return this.type === ITEM_TYPES.Quiz 
    }
    isReviewWords(){
        return this.reviewWords;
    }
    showNewWords(){
        return this.isLeitner() && this.isReviewWords();
    }
    isChatInputAllowed(){
        const allowed = this.isDictionary() || this.isChat()
        // this.logger.debug("isChatInputAllowed", allowed)
        return allowed;
    }
    isChatTutorial(){
        return this.tutorial;
    }
    setFinishedTutorial(isFinished: boolean){
      this.finishedTutorial = isFinished;
    }
    isFinishedTutorial(){
        return this.finishedTutorial;
    }
    setViewLoaded(isLoaded: boolean){
        this.viewLoaded = isLoaded;
    }
    isViewLoaded(){
        return this.viewLoaded;
    }
}